import { useAudio } from '@/hooks/audio';

import { useAppSelector } from '@/state/store';
import getAudioContent from '@/theme/audiocontent';

export const useTheme = () => {
    const theme = useAppSelector((state) => state.app.theme);
    return theme;
};

export function AudioProvider() {
    useAudio(getAudioContent());

    return <></>;
}
